//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('departments', {
//        templateUrl: 'views/components/views/departments/departments.template.html?v=' + module.version, 
//        controllerAs: 'vm',
//        controller: ['stateService', 'departmentsService', function (stateService, departmentsService) {
//            const vm = this;

//            vm.model = {
//                itemsListDepartments: []
//            };

//            async function loadDepartments() {
//                vm.model.itemsListDepartments = await departmentsService.listDepartments();
//            }
            
//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                };

//                switch (state) {
//                    case 'department':
//                        go({ department_id: '0' });
//                        break;
//                    default:
//                        break;
//                }
//            };
            
//            vm.$onInit = function () {
//                loadDepartments();
//            };
//        }]
//    });
//})();
